module.exports = __webpack_public_path__ + "static/antd-table-filtering-344ff5f06156971e0ddef200257773e4.png";